/**
 * @module project/components/participate_form/mobile
 */
import React, { PropTypes } from 'react';
import WatchlistButton from 'project/containers/watch_project_button';

/**
 * Participate upload form step for mobile devices which tells user to switch to
 * desktop.
 *
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const SwitchToDesktopStep = ({ onCloseForm, canWatch }) => (
  <div>
    <div className="modal-header">
      <h5>Switch to desktop...</h5>
    </div>
    <div className="modal-content participate-mobile">
      <div className="participate-content">
        <h2>Hey, we love your enthusiasm</h2>
        <p>In our experience, project submissions are done best on bigger screens.</p>
        <p>
          We recommend that you submit your work when you return to your laptop or desktop.
          {canWatch?  " You can watch this project to easily return to it later.":""}
        </p>
      </div>
      <div className="modal-actions">
          {canWatch &&
          <WatchlistButton classes="btn btn-primary btn-with-icon btn-block" />}
          <button
            type="button"
            className="btn btn-text btn-block btn-cancel"
            onClick={onCloseForm}
          >
            Cancel
          </button>
      </div>
    </div>
  </div>
);

/**
 * PropTypes.
 *
 * @property {func} onCloseForm - function called when close form button is clicked
 * @property {bool} canWatch - whether logged in user can watch the project
 */
SwitchToDesktopStep.propTypes = {
  onCloseForm: PropTypes.func,
  canWatch: PropTypes.bool,
};

export default SwitchToDesktopStep;



// WEBPACK FOOTER //
// ./project/components/participate_form/switch_to_desktop.jsx